export default {
    adaptHtml(html, color, backgroundColor){
      if(html == null)
      {
        return '';
      }

      var fontFamily = color.font_family ? 'font-family: ' + color.font_family : '';
      var textShadow = color.outline ? 'text-shadow: -1px -1px 0 '+color.outline+', 1px -1px 0 '+color.outline+', -1px 0px 0 '+color.outline+', 1px 0px 0 '+color.outline+';' : '';
      var textTransform = color.is_lower_case ? 'text-transform: capitalize' : 'text-transform: uppercase';
      html = html.replace(/<h1/g, "<h1 style='font-size: 23px; color: "+ color.color+"; "+ fontFamily +";"+textShadow+"; "+textTransform+"' ");
      html = html.replace(/<h2/g, "<h2 style='color: "+ color.color+"; "+ fontFamily+";"+textShadow+"; "+textTransform+"' ");
      html = html.replace(/<a href=/g, "<a class='link-in-quill-text' style='background-color: "+backgroundColor+"' href=");
      return html;
    }
}